import { createContext, useContext } from 'react'

export interface SidebarContextValue {
  isMobile: boolean
  open: boolean
  setOpen: (open: boolean) => void
}

export const SidebarContext = createContext<SidebarContextValue>({
  isMobile: false,
  open: false,
  setOpen: () => {},
})

export function useSidebar() {
  return useContext(SidebarContext)
}
